import sharedConstVars from '@qred/shared-constants';
import { MatchedMediaBreakPoints } from '~/Interfaces';

const constVars = {
  ...sharedConstVars,
  PARAMS_SIGNER_SIGNED_SUCCESS: 'signersuccess',
  PARAMS_SIGNER_ALREADY_SIGNED: 'signeralreadysigned',
  ROUTE_LOAN_ADDITIONAL_SIGNER_OLD: 'signer', // Old route for loan additional signer, redirect to ROUTE_LOAN_ADDITIONAL_SIGNER
  ROUTE_LOAN_ADDITIONAL_SIGNER: 'loan-additional-signer', // New route for '/signer'
  ROUTE_SIGNER_ERROR: 'additional-signer-error',
  ROUTE_ADDITIONAL_SIGNER_AUTH_OLD: 'additional-signer', // Old route for OTP for loan and card, redirect to ROUTE_ADDITIONAL_SIGNER_AUTH
  ROUTE_ADDITIONAL_SIGNER_AUTH: 'additional-signer-auth', // New route for OTP for '/additional-signer
  ROUTE_ESKAT: 'eskat',
  ROUTE_CARD_ADDITIONAL_SIGNER_OLD: 'p-cardoffer-signer', // Old route for card offer signer, redirect to ROUTE_CARD_ADDITIONAL_SIGNER
  ROUTE_CARD_ADDITIONAL_SIGNER: 'card-additional-signer', // New route for '/p-cardoffer-signer'
  ROUTE_THANK_YOU_CONTINUE_IN_APP: 'thankyou-continue-in-app',
  ROUTE_THANK_YOU_WAITING_ADDITIONAL_SIGNER:
    'thankyou-card-waiting-additional-signer',
  ROUTE_LOAN_APPLICATION_OLD: 'onboarding',
  ROUTE_LOAN_APPLICATION: 'loan-application',
  ROUTE_CARD_APPLICATION: 'card-application',
  ROUTE_LOAN_OFFER_OLD: 'onboarding-offer',
  ROUTE_LOAN_OFFER: 'loan-offer',
  ROUTE_CARD_OFFER_OLD: 'card-onboarding-offer',
  ROUTE_CARD_OFFER: 'card-offer',
  AUTH_CLIENT_ID: 'https://onboarding/clientId',
  AUTH_USER_DATE_OF_BIRTH: 'https://onboarding/dateOfBirth',
  ROUTE_MAINTENANCE: 'maintenance',
  ROUTE_BANK_CONNECTION_RESULT: 'bank-connection-result',
  ROUTE_BANK_CONNECTION: 'bank-connection',
  ROUTE_UPDATE_APPLICATION: 'update-application',
};

export default constVars;

export const V2 = 'v2';

export const MediaQueries: Record<keyof MatchedMediaBreakPoints, string> = {
  mobile: '(max-width: 480px)',
  mobileLandscape: '(orientation: landscape) and (max-height: 480px)',
  smallScreen: '(max-width: 688px)',
  smallScreenPortrait: '(orientation: portrait) and (max-width: 688px)',
  mediumScreen: '(min-width: 689px)',
  bigScreen: '(min-width: 1024px)',
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)',
  tablet: '(min-width: 481px) and (min-height: 481px)',
  desktop: '(min-width: 1024px)',
};

export const openBankingMaxAspspsResultsToShow = 50;
